import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { CartItemBody } from "./carditemBody";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Offcanvas } from "bootstrap";
import { EmptyCart } from "../../Common/emptyCart";
import { MyCartSideSkeleton } from "../../../Skeleton/myCartSideSkeleton";
import { PAGES } from "../../../routeConfig";
import { ConvertToFloat, isValidArray } from "../../Common/common";
import { useAuth } from "../../../Context/AuthContext";

export const CartSidePopup = () => {
  const globalcontext = useContext(GlobalContext);
  const [CartItem, setCartItem] = useState(null);
  const [isClarification, setIsClarification] = useState(false);
  const { isAuthenticated } = useAuth();
  const offcanvasRef = useRef(null);
  const closeRef = useRef(null);
  const history = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (globalcontext.CartItem) setCartItem(globalcontext.CartItem);
    if (globalcontext.clarificationItem && isValidArray(globalcontext.clarificationItem)) {
      setIsClarification(true);
    } else {
      setIsClarification(false);
    }
  }, [globalcontext.CartItem, globalcontext.clarificationItem]);

  const handleNavigation = () => {
    if (offcanvasRef.current?.matches(".show, .showing")) closeRef.current.click();
  };
  useEffect(() => {
    handleNavigation();
  }, [location]);

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex={-1}
      id="cartPopup"
      ref={offcanvasRef}
      aria-labelledby="offcanvasTopLabel"
    >
      <div className="offcanvas-header cartPopup-header">
        <h5 id="offcanvasTopLabel">My Cart</h5>
        <p ref={closeRef} className="text-reset" data-bs-dismiss="offcanvas" aria-label="Close">
          <i className="fa-solid fa-xmark" />
        </p>
      </div>

      {!isAuthenticated ? (
        <EmptyCart showHomeButton={false} showQuickOrderButton={true} />
      ) : CartItem && isValidArray(CartItem.cartItem) ? (
        <Fragment>
          <div className="offcanvas-body cartPopup-body">
            <div className="cartPoup-info">
              <h6>Your Cart</h6>
              <p>({CartItem.totalItem} Items)</p>
            </div>
            <CartItemBody cartItemList={CartItem.cartItem} totalItem={CartItem.totalItem} showToaster={false} />
          </div>
          <div className="offcanvas-footer cartPopup-footer">
            {/* Subtotal */}
            <div className="cart-popup-subtotal">
              <div className="cartPopup-subtotal">
                <h6>
                  Sub Total <span>({CartItem.totalItem} Items)</span>
                </h6>
                <p>Price Ex GST</p>
              </div>
              <div className="subtotal-price">${ConvertToFloat(CartItem.totalcost)}</div>
            </div>
            {/* Subtotal */}
            <div className="subtotal-btn">
              <Link to="/OrderDetails" onClick={handleNavigation} className="btn btn-products btn-unavailable">
                View Cart
              </Link>
              <div className="button-effect popup-checkout-btn">
                <Link
                  onClick={handleNavigation}
                  to={isClarification ? PAGES.ORDER_DETAIL : PAGES.CHECKOUT}
                  className="btn btn-products btn-addcart green-btn"
                >
                  Checkout
                </Link>
              </div>
            </div>
          </div>
        </Fragment>
      ) : CartItem ? (
        <>
          <EmptyCart showHomeButton={false} showQuickOrderButton={true} />
        </>
      ) : (
        <MyCartSideSkeleton count={3} />
      )}
    </div>
  );
};
